module.exports = __webpack_public_path__ + "static/project-industrial_the-hub.29a3f90d.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/project-industrial_the-hub.jpg
// module id = 290
// module chunks = 0 1